module.exports = __webpack_public_path__ + "media/bundles/info-f702e335.svg";